import React from "react";
const CardText = (props) => {
  return (
    <div id="card-text" className="display-flex">
      {props.children}
      <h3 className="scaffold cardText">{props.title}</h3>
      <p className="scaffold cardContent">{props.text}</p>
    </div>
  );
};

export default CardText;
